import { ApiState, Action } from '../../types';
import { serviceReducer, callService } from '../../shared/hooks/serviceReducer';
import { DashboardList, DashboardFilter, Phase, Period } from '../../services/types/Dashboard';

export type DashboardHook = [
  DashboardList | null,
  boolean,
  DashboardFilter,
  React.Dispatch<DashboardAction>,
  (val: boolean) => void,
  () => void
];

export type DashboardAction =
  | Action<DashboardList, DashboardFilter>
  | { type: 'GANTT_MODE'; value: boolean }
  | { type: 'PERIOD'; value: Period }
  | { type: 'PERIOD_RELATIVE'; increment: boolean }
  | { type: 'PHASE'; value: Phase | null }
  | { type: 'MEMBER'; value: number }
  | { type: 'PAGE'; value: number }
  | { type: 'PAGE_SIZE'; value: number }
  | { type: 'ORDER'; column: string; descending: boolean };

const reducer = (
  state: ApiState<DashboardList, DashboardFilter>,
  action: DashboardAction
): ApiState<DashboardList, DashboardFilter> => {
  switch (action.type) {
    case 'GANTT_MODE': {
      const filter = { ...state.filter, ganttMode: action.value };
      return callService(state, filter);
    }
    case 'PERIOD': {
      const filter = { ...state.filter, period: action.value, periodRelative: 0 };
      return callService(state, filter);
    }
    case 'PERIOD_RELATIVE': {
      const value = state.filter.periodRelative + (action.increment ? 1 : -1);
      const filter = { ...state.filter, periodRelative: value };
      return callService(state, filter);
    }
    case 'PHASE': {
      const filter = { ...state.filter, phase: action.value };
      return callService(state, filter);
    }
    case 'MEMBER': {
      const filter = { ...state.filter, memberUserId: action.value };
      return callService(state, filter);
    }
    case 'PAGE':
      return callService(state, { pageNumber: action.value });
    case 'PAGE_SIZE':
      return callService(state, { pageSize: action.value });
    case 'ORDER':
      return callService(state, { sortField: action.column, sortDescending: action.descending });
    default:
      return serviceReducer(state, action);
  }
};

export default reducer;
